import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiEndpointInfo } from './api-endpoint-info.model';
import { timeout } from 'rxjs/operators';
import { PagingRequest } from '../shared-api/models/paging.model';

export enum HttpMethod {
    Get,
    Post,
    Put,
    Patch,
    Delete,
}

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    protected baseApiUrl = environment.baseApiUrl;

    constructor(protected http: HttpClient) {}

    private readonly headers = new HttpHeaders().set(
        'Content-Type',
        'application/json'
    );

    apiRequest<T>(
        url: string,
        httpMethod: HttpMethod,
        httpBody?: any,
        timeoutInSecs = 15
    ): Observable<T> {
        if (url.length > 2080) {
            const urlWithoutParams = url.split('?');
            throw new URIError(
                `apiRequest URI (${urlWithoutParams[0]}) is too long. This may indicate an API error. Consult the factory.`
            );
        }
        return this.http
            .request<T>(HttpMethod[httpMethod], url, {
                headers: this.headers,
                body: httpBody,
            })
            .pipe(timeout(timeoutInSecs * 1000));
    }

    apiUploadRequest<T>(
        url: string,
        formData: FormData,
        timeoutInSecs: number
    ): Observable<T> {
        return this.http
            .post<T>(url, formData)
            .pipe(timeout(timeoutInSecs * 1000));
    }

    apiGetRequestForCsv<T>(url: string): Observable<any> {
        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .append('Accept', 'text/csv');
        return this.http
            .get<T>(url, { headers, responseType: 'blob' as 'json' })
            .pipe(timeout(900000));
    }

    buildPagingRequest(options: PagingRequest): string {
        let result = [];
        if(options.sortField)
            result.push(`sortField=${options.sortField}`);
        if(options.sortOrder !== undefined)
            result.push(`sortOrder=${options.sortOrder === 1 ? 'asc' : 'desc'}`);
        if(options.pageSize !== undefined)
            result.push(`pageSize=${options.pageSize}`);
        if(options.pageIndex !== undefined)
            result.push(`pageIndex=${options.pageIndex}`);
        if(options.searchString)
            result.push(`searchString=${options.searchString}`);
        if(options.filters) {
            let params: string[] = []
            options.filters.forEach((f, i) => {
                params.push(`Filters[${i}].FieldName=${f.fieldName}&Filters[${i}].Value=${f.value}&Filters[${i}].Operator=${f.operator}`)
            })
            result.push(params.join('&')); 
        }
        return result.join('&');
    }
}
